import { ReactNode } from "react";
import { PulseLoader } from "react-spinners";
import styled from "styled-components";

interface LoadingOverlayProps {
  when: boolean;
  children: ReactNode;
}

export const LoadingOverlay = ({ when, children }: LoadingOverlayProps) => {
  const overlay = when ? (
    <Styled.div.overlay className="position-absolute top-0 d-flex align-items-center justify-content-center w-100 h-100 bg-light text-white text-center rounded">
      <PulseLoader color="var(--bt-primary)" />
    </Styled.div.overlay>
  ) : null;

  return (
    <div className="position-relative h-100 d-flex flex-column overflow-hidden">
      {overlay}
      {children}
    </div>
  );
};

const Styled = {
  div: {
    overlay: styled.div`
      --bs-bg-opacity: 0.7;

      z-index: 1021;
    `,
  },
};
